// 2P AI — scheda progetto nella griglia (§8.1). Etichetta server ben visibile (chip accent-soft).
// NB: il tag "tipo" non è mostrato in R1 perché l'API non lo fornisce ancora (arriva in R3).
import type { ReactNode } from 'react';
import { Icon } from './Icon';
import { onCardKey } from '../lib/a11y';
import type { Project } from '../lib/types';

export function ProjectCard({ project, serverName, summary, onOpen }: { project: Project; serverName: string; summary: ReactNode; onOpen: () => void }) {
  return (
    <div className="card" role="button" tabIndex={0} onClick={onOpen} onKeyDown={onCardKey(onOpen)}>
      <div className="top"><div className="name">{project.name}</div></div>
      <div className="meta">
        <div className="srv"><Icon name="dns" /><span className="nm">{serverName}</span></div>
        <div className="row"><Icon name="folder" /><span className="path">{project.working_dir}</span></div>
      </div>
      <div className="foot">
        <span className="sline">{summary}</span>
        <span className="open">Apri<Icon name="arrow_forward" /></span>
      </div>
    </div>
  );
}
